module.exports = {
  "id": "match the beat",
  "title": "Match the Beat",
  "category": "other",
  "tutorialLink": "https://www.youtube.com/watch?v=syaonxa6Ank",
  "thumbnail": "/provision/projects/match the beat/match the beat.png",
  "toolbar":{
    "glitches":[],
    "parts":[]
  },
  "scenes": [{
    "id": "main",
    "metadata": "main.json",
    "sb3": "match the beat.sb3"
  }],
  "levels": [
    "main"    
  ]
}
;